import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from '../ui/button';

const navLinks = [
  { name: 'Accueil', href: '/' },
  { name: 'Audit qualité', href: '/audit-qualite-vaucluse' },
  { name: 'Formations', href: '/formateur-polyvalent-vaucluse' },
  { name: 'Blog', href: '/blog' },
  { name: 'À propos', href: '/a-propos' },
  { name: 'Contact', href: '/contact' },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-header" data-testid="header">
      {/* Top bar */}
      <div className="bg-slate-900 text-white py-2 hidden md:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-end items-center gap-6 text-sm">
          <a 
            href="tel:0620968980" 
            className="flex items-center gap-2 hover:text-blue-300 transition-colors"
            data-testid="phone-link-top"
          >
            <Phone className="w-4 h-4" />
            06 20 96 89 80
          </a>
          <a 
            href="mailto:mehdi.richa.formation@gmail.com" 
            className="flex items-center gap-2 hover:text-blue-300 transition-colors"
            data-testid="email-link-top"
          >
            <Mail className="w-4 h-4" />
            mehdi.richa.formation@gmail.com
          </a>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Navigation principale">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex flex-col" 
            data-testid="logo-link"
          >
            <span className="font-serif text-xl md:text-2xl font-bold text-slate-900 tracking-tight">
              Mehdi Richa
            </span>
            <span className="text-xs md:text-sm text-slate-600 font-medium">
              Formateur et auditeur qualité
            </span>
          </Link>

          {/* Desktop navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  isActive(link.href)
                    ? 'bg-blue-600 text-white'
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <div className="hidden lg:block">
            <Button 
              asChild 
              className="rounded-full bg-blue-600 hover:bg-blue-700 px-6"
              data-testid="cta-contact-header"
            >
              <a href="mailto:mehdi.richa.formation@gmail.com">
                Me contacter
              </a>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            className="lg:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-menu"
            data-testid="mobile-menu-button"
          >
            <span className="sr-only">Ouvrir le menu</span>
            {mobileMenuOpen ? (
              <X className="h-6 w-6" aria-hidden="true" />
            ) : (
              <Menu className="h-6 w-6" aria-hidden="true" />
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div 
            id="mobile-menu" 
            className="lg:hidden py-4 border-t border-slate-200"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${
                    isActive(link.href)
                      ? 'bg-blue-600 text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-4 border-t border-slate-200 mt-2">
                <a 
                  href="tel:0620968980" 
                  className="flex items-center gap-2 px-4 py-2 text-slate-600"
                  data-testid="mobile-phone-link"
                >
                  <Phone className="w-4 h-4" />
                  06 20 96 89 80
                </a>
                <a 
                  href="mailto:mehdi.richa.formation@gmail.com" 
                  className="flex items-center gap-2 px-4 py-2 text-slate-600"
                  data-testid="mobile-email-link"
                >
                  <Mail className="w-4 h-4" />
                  mehdi.richa.formation@gmail.com
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
